exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-border[data-v-202f09fc]{border-top:0!important}@media (max-width:575.98px){.no-border[data-v-202f09fc]{border-top:1px solid #dee2e6!important}}@media (min-width:768px){.col-md-auto[data-v-202f09fc]{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-202f09fc","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/PartnerMedia.vue
// module id = 123
// module chunks = 0